export const TRANSACTION_ELEMENTS = {
  tWidget: document.querySelector('.aafp_transaction-widget') as HTMLElement,
  tHeader: document.querySelector('.aafp_t-header') as HTMLElement,
  tPaidDollars: document.querySelector('.aafp_t-paid-dollars') as HTMLElement,
  tCustomerName: document.querySelector('.aafp_t-customername') as HTMLElement,
  tCustomerAccount: document.querySelector('.aafp_t-customeraccount') as HTMLElement,
  tPartnerName: document.querySelector('.aafp_t-partnername') as HTMLElement,
  tPaymentMethod: document.querySelector('.aafp_t-paymentmethod') as HTMLElement,
  tPaymentReference: document.querySelector('.aafp_t-paymentreference') as HTMLElement,
  tCardName: document.querySelector('.aafp_t-cardname') as HTMLElement,
  tCardNumber: document.querySelector('.aafp_t-cardnumber') as HTMLElement,
  tCardGroupName: document.querySelector('.aafp_t-cardGroupName') as HTMLElement,
  tTraining: document.querySelector('.aafp_t-training') as HTMLElement,
  tTrainingComplete: document.querySelector('.aafp_t-trainingcomplete') as HTMLElement,
  tTerminalName: document.querySelector('.aafp_t-terminalname') as HTMLElement,
  tTerminalId: document.querySelector('.aafp_t-terminalid') as HTMLElement,
  tGallons: document.querySelector('.aafp_t-terminalGallons') as HTMLElement,
  tHose: document.querySelector('.aafp_t-terminalhose') as HTMLElement,
}